import { render, staticRenderFns } from "./DoctorinformationForm.vue?vue&type=template&id=2e3be14b&"
import script from "./DoctorinformationForm.vue?vue&type=script&lang=js&"
export * from "./DoctorinformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports